import React, { useEffect, useState } from "react";

// import MenuCliente  from "../MenuCliente";
import HeaderPortalVendedor from "../HeaderPortalVendedor";
import Carregando from "../../Componentes/Carregando";
import MenuCliente from "../MenuCliente";

import { HiOutlineArrowSmLeft } from "react-icons/hi";
import MenuPrinc from "../../Componentes/MenuPrinc";

// import { apiLeo } from "../../services/api.js";
// import { PostApi, GetApi, getProjeto, set_Projeto } from "../../services/auth.js";
import { MudaVisibilidade, alternaClasse } from "../../services/funcoes";
import { useHistory } from "react-router-dom";

import { URLBunge } from "../../Componentes/Config";

import "jodit";
import "jodit/build/jodit.min.css";
import JoditEditor from "jodit-react";

import { Container, CadastrosCSS } from "./styles";

import {
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBInputGroup,
  MDBBtn,
  MDBDataTable,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBAlert,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBCollapse,
} from "mdbreact";

const meses = new Array(
  "janeiro",
  "fevereiro",
  "março",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro"
);
//TELEFONE ANTIGO
const TEL_ANDTIGO = {
  columns: [
    {
      label: "Tipo",
      field: "coluna1",
      sort: "asc",
    },
    {
      label: "Numero",
      field: "coluna2",
      sort: "asc",
    },
    {
      label: "Data de Cadastro",
      field: "data_cad",
      sort: "asc",
    },
    {
      label: "Data de Atualização",
      field: "data_atu",
      sort: "asc",
    },
    {
      label: "Status",
      field: "excluido",
      sort: "asc",
    },
  ],
  rows: [],
};

//ENDEREÇO ANTIGO
const END_ANTIGO = {
  columns: [
    {
      label: "Tipo",
      field: "coluna1",
      sort: "asc",
    },
    {
      label: "Endereço",
      field: "coluna2",
      sort: "asc",
    },
    {
      label: "Bairro",
      field: "coluna4",
      sort: "asc",
    },
    {
      label: "CEP",
      field: "coluna5",
      sort: "asc",
    },
    {
      label: "Cidade/Estado",
      field: "coluna6",
      sort: "asc",
    },
    {
      label: "Data de Cadastro",
      field: "data_cad",
      sort: "asc",
    },
    {
      label: "Data de Atualização",
      field: "data_atu",
      sort: "asc",
    },
    {
      label: "Status",
      field: "excluido",
      sort: "asc",
    },
  ],
  rows: [],
};

//ABA LOJA tabela DADOS DO PROPRIETARIO
const prop = {
  columns: [
    {
      label: "Nome",
      field: "coluna1",
      sort: "asc",
    },
    {
      label: "Cargo",
      field: "cargo",
      sort: "asc",
    },
    {
      label: "CPF",
      field: "coluna2",
      sort: "asc",
    },
    {
      label: "E-mail",
      field: "coluna3",
      sort: "asc",
    },
    {
      label: "Data de Cadastro",
      field: "coluna4",
      sort: "asc",
    },
    {
      label: "Data de Atualizacao",
      field: "coluna5",
      sort: "asc",
    },
    {
      label: "Telefone Celular",
      field: "coluna6",
      sort: "asc",
    },
    {
      label: "Consultar",
      field: "coluna7",
      sort: "asc",
    },
  ],
  rows: [],
};

//ABA tabela LOG DE SISTEMA
const LOG_SISTEMA = {
  columns: [
    {
      label: "Codigo LOG",
      field: "codigo",
      sort: "asc",
      width: 100,
    },
    {
      label: "Data",
      field: "data",
      sort: "asc",
      width: 270,
    },
    {
      label: "Tabela",
      field: "tabela",
      sort: "asc",
      width: 200,
    },
    {
      label: "Campo",
      field: "campo",
      sort: "asc",
      width: 150,
    },
    {
      label: "De",
      field: "de",
      sort: "asc",
      width: 150,
    },
    {
      label: "Para",
      field: "para",
      sort: "asc",
      width: 100,
    },
    {
      label: "Alterado por",
      field: "alterado",
      sort: "asc",
      width: 100,
    },
  ],
  rows: [],
};

const METAS_HISTORICO_SIS = {
  columns: [
    {
      label: "Industria",
      field: "industria",
      sort: "asc",
      width: 100,
    },
    {
      label: "Meta",
      field: "meta",
      sort: "asc",
      width: 270,
    },
    {
      label: "Realizado",
      field: "realizado",
      sort: "asc",
      width: 200,
    },
    {
      label: "Mes",
      field: "mes",
      sort: "asc",
      width: 150,
    },
  ],
  rows: [],
};

function ConsultarClientes(props) {
  const TOKEN = localStorage.getItem("c_token");
  const EMAIL_USUARIO = localStorage.getItem("c_email");
  const history = useHistory();

  const [carregando, setCarregando] = useState(false);
  const [collapseID, setCollapseId] = useState("");
  const [activeItem, setActiveItem] = useState("1");
  const [modal4, setModal4] = useState(false); //antigo endereço
  const [modal5, setModal5] = useState(false); //novo endereço
  const [modal6, setModal6] = useState(false); //antigo telefone
  const [modal7, setModal7] = useState(false); //novo telefone
  const [modal10, setModal10] = useState(false);
  const [modal777, setModal777] = useState(false);
  const [modal33, setModal33] = useState(false);
  const [logsistema, setLogsistema] = useState({});
  const [telantigo, setTelantigo] = useState({});
  const [endantigo, setEndantigo] = useState({});
  const [metasHistoricoSis, setMetasHistoricoSis] = useState({});

  const [atendimento, setAtendimento] = useState("");
  const [motivos, setMotivos] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [usersDep, setUsersDep] = useState([]);
  const [DepEscolhido, setDepEscolhido] = useState("");
  const [UserEscolhido, setUserEscolhido] = useState("");
  const [MotivoEscolhido, setMotivoEscolhido] = useState("");
  const [MotivoEscolhidoDesc, setMotivoEscolhidoDesc] = useState("");

  const [historicoMSG, setHistoricoMSG] = useState("");
  const [ocorrenciaSTU, setOcorrenciaSTU] = useState(0);

  // CLIENTE - DADOS DO CLIENTE
  const [cpf, setCpf] = useState("");
  const [cpfIncognito, setCpfIncognito] = useState("");
  const [nome, setNome] = useState("");
  const [cod, setCod] = useState("");
  const [categoria, setCategoria] = useState("");
  const [dataNasc, setDataNasc] = useState("");
  const [cargo, setCargo] = useState("");
  const [email, setEmail] = useState("");
  const [telFixo, setTelFixo] = useState("");
  const [celular, setCelular] = useState("");
  const [sexo, setSexo] = useState([]);
  const [lojas, setLojas] = useState([]);
  const [loja, setLoja] = useState({ infoSistema: {}, endereco: {} });
  const [propri, setPropri] = useState([]);
  const [Pontos, setPontos] = useState("");
  const [Bonus, setBonus] = useState("");
  const [Premios, setPremios] = useState("");
  const [Expirados, setExpirados] = useState("");

  // CLIENTE - Cadastro Telefone
  const [Tipo_Telefone, setTipo_Telefone] = useState("515");
  const [DDD_Telefone, setDDD_Telefone] = useState("");
  const [Numero_Telefone, setNumero_Telefone] = useState("");

  // CLIENTE - Telefone antigos
  const [Telefone_Antigo, setTelefone_Antigo] = useState([]);

  //  CLIENTE - Endereço do cliente
  const [Tipo_Endereco, setTipo_Endereco] = useState([]);
  const [endereco, setEndereco] = useState({});
  const [Numero, setNumero] = useState("");
  const [Complemento, setComplemento] = useState("");
  const [Bairro, setBairro] = useState("");
  const [Cep, setCep] = useState("");
  const [Cidade, setCidade] = useState("");
  const [uf, setUf] = useState("");
  const [sexoID, setSexoID] = useState("");

  //  CLIENTE - Cadastro novo Endereço do cliente
  const [Tipo_Endereco_Cadastro, setTipo_Endereco_Cadastro] = useState("32");
  const [Endereco_Cadastro, setEndereco_Cadastro] = useState("");
  const [Numero_Cadastro, setNumero_Cadastro] = useState("");
  const [Complemento_Cadastro, setComplemento_Cadastro] = useState("");
  const [Bairro_Cadastro, setBairro_Cadastro] = useState("");
  const [Cep_Cadastro, setCep_Cadastro] = useState("");
  const [Cidade_Cadastro, setCidade_Cadastro] = useState("");
  const [Uf_Cadastro, setUf_Cadastro] = useState("");

  // CLIENTE - Cadastro novo Endereço do cliente
  const [Endereco_Antigo, setEndereco_Antigo] = useState([]);

  // CLIENTE Historico de atendimento
  const [Historico_Cliente, setHistorico_Cliente] = useState([]);

  // CLIENTE - Info de sistema do cliente
  const [infoSistema, setInfoSistema] = useState({});
  const [optStatus, setOptStatus] = useState(1);
  const [Ultima_Alteracao, setUltima_Alteracao] = useState("");

  // LOJA - DADOS DA LOJA
  const [cnpj, setCnpj] = useState("");
  const [Razao, setRazao] = useState("");
  const [Codigo_loja, setCodigo_loja] = useState("");
  const [Categoria_loja, setCategoria_loja] = useState("");
  const [Grupo_loja, setGrupo_loja] = useState("");
  const [IE, setIE] = useState("");
  const [Email_Loja, setEmail_Loja] = useState("");
  const [Segmento_Loja, setSegmento_Loja] = useState("");
  const [Pontos_Loja, setPontos_Loja] = useState("");
  const [Inauguracao, setInauguracao] = useState("");
  const [telefoneLoja, settelefoneLoja] = useState("");

  //LOJA - Info de sistema
  const [Qtd_Atendimento_Loja, setQtd_Atendimento_Loja] = useState("");
  const [Acesso_site_Loja, setAcesso_site_Loja] = useState("Ativo");
  const [Site_Sao_Loja, setSite_Sao_Loja] = useState("Só Consulta");
  const [Ultima_Alteracao_Loja, setUltima_Alteracao_Loja] = useState("");

  //LOJA - TABELA PROPRIETARIO
  const [Proprietario, setProprietario] = useState("");
  const [CPF_Proprietario, setCPF_Proprietario] = useState("");
  const [Email_Proprietario, setEmail_Proprietario] = useState("");
  const [Data_Cadastro, setData_Cadastro] = useState("");
  const [Data_Atualizacao, setData_Atualizacao] = useState("");
  const [Celular_Proprietario, setCelular_Proprietario] = useState("");

  // LOG DE OPERAÇÕES
  const [Operacoes, setOperacoes] = useState([]);
  const [resumo, setResumo] = useState([]);
  const [config, setConfig] = useState({
    readonly: false,
    uploader: {
      insertImageAsBase64URI: true,
    },
  });
  const [ocorreciaSelecionada, setOcorreciaSelecionada] = useState({
    listaHistoricos: [],
  });
  const [status, setStatus] = useState([]);
  const [permissoes, setPermissoes] = useState([]);
  const [StatusCliente, setStatusCliente] = useState([]);
  const [loginleo, setLoginleo] = useState("");
  const [metas, setMetas] = useState([]);
  const [metasHistorico, setMetasHistorico] = useState([]);
  const [anoSelect, setAnoSelect] = useState("2020");
  const [MetaGrupo, setMetaGrupo] = useState("");
  const [TipoTrans, setTipoTrans] = useState([]);
  const [BonificacaoTipoTrans, setBonificacaoTipoTrans] = useState("");
  const [BonificacaoPontos, setBonificacaoPontos] = useState(0);

  const [statusID, setStatusID] = useState("");
  const [StatusEscolhido, setStatusEscolhido] = useState("");
  const [myLuxottica, setMyLuxottica] = useState("");
  const [codExt, setCodExt] = useState("");

  const [proprietario, setProprietarios] = useState("");

  function toggleModal(nr) {
    if (nr === 4) {
      setModal4((oldValue) => !oldValue);
    } else if (nr === 5) {
      setModal5((oldValue) => !oldValue);
    } else if (nr === 6) {
      setModal6((oldValue) => !oldValue);
    } else {
      setModal7((oldValue) => !oldValue);
    }
  }

  function toggle(tab) {
    if (activeItem !== tab) {
      setActiveItem(tab);
    }
  }

  function toggleCollapse(collapseID, i) {
    setCollapseId((oldValue) => (oldValue !== collapseID ? collapseID : ""));
    // setState(prevState => ({
    //   collapseID: prevState.collapseID !== collapseID ? collapseID : ""
    // }));

    var id = document.getElementsByClassName("help");
    if (id[0] != undefined) {
      id[0].classList.remove("help");
    }
    alternaClasse("paizao" + i, "help");
  }

  useEffect(async () => {
    // MudaVisibilidade("LoadingPage");
    // set_Projeto(2329681);
    var cpf = props.match.params.cpf;
    var pesquisa = cpf.match("[0-9]+");
    if (pesquisa[0] != cpf) {
      cpf = atob(cpf);
    }
    var cpfIncognito = cpf.substring(0, 2) + "x.xxx.xxx-" + cpf.substring(9);
    // await setState({ cpf, cpfIncognito});
    setCpf(cpf);
    setCpfIncognito(cpfIncognito);

    // await setState({ atendimento: props.match.params.atendimento });
    setAtendimento(props.match.params.atendimento);

    // setState({ logsistema: logsistema, telantigo: telantigo, endantigo: endantigo });
    setLogsistema(LOG_SISTEMA);
    setTelantigo(TEL_ANDTIGO);
    setEndantigo(END_ANTIGO);

    var resAtendimento = { data: { listaAtendimentos: [] } };
    // await GetApi('Atendimentos/Listar/' + getProjeto() + '/' + cpf);
    // setState({ Historico_Cliente: resAtendimento.data.listaAtendimentos });
    setHistorico_Cliente(resAtendimento.data.listaAtendimentos);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const resCliente = await fetch(
      `${URLBunge}/api/Cliente/BuscaPorCPF/2329681/` + cpf,
      requestOptions
    ).then((response) => response.json());

    setNome(resCliente.nome);
    setEmail(resCliente.email);
    setSexo(resCliente.sexo);
    setCelular(resCliente.celular);
    setTelFixo(resCliente.telFixo);
    setCargo(resCliente.cargo);
    setEndereco(resCliente.endereco);

    setLoja(resCliente.loja);
    setLojas(resCliente.lojas);

    console.log("***DADOS DO CLIENTE", resCliente);

    // var resCliente = {data: {telefones: []}}
    // await GetApi('Cliente/BuscaPorCPF/' + getProjeto() + '/' + cpf);

    // OBS: VERFICAR OS DADOS
    // setState({ ...resCliente.data });

    CarregaPermissoes();
    buscaMotivos();
    buscaLogs();
    CarregaPontuacao(cpf);
    CarregaStatus();
    CarregaTiposTrans();

    // if (getProjeto() == 2334185) {
    //   CarregaLoginLeo();
    // }

    if (resCliente.infoSistema.status === "Ativo") {
      // setState({ optStatus: 0 });
      setOptStatus(0);
    }

    var ult = "";
    if (resCliente.infoSistema.ultimaAlteracao != null) {
      var ult = resCliente.infoSistema.ultimaAlteracao.split("T");
      ult = ult[0].split("-").reverse().join("/");
    }

    var dat = "";
    if (resCliente.dataNasc != null) {
      var dat = resCliente.dataNasc.split("T");
      var dat = dat[0].split("-").reverse().join("/");
    }

    var ultL = "";
    if (resCliente.loja != null) {
      if (resCliente.loja.infoSistema.ultimaAlteracao != null) {
        var ultL = resCliente.loja.infoSistema.ultimaAlteracao.split("T");
        ultL = ultL[0].split("-").reverse().join("/");
      }
    }

    setUltima_Alteracao(ult);
    setDataNasc(dat);
    setUltima_Alteracao_Loja(ultL);

    var tA = TEL_ANDTIGO;
    if (resCliente.telefones) {
      if (resCliente.telefones.length > 0) {
        resCliente.telefones.forEach((tel) => {
          var data_cad = "null";
          if (tel.dataCad !== null) {
            var dataCad = tel.dataCad.split("T");
            data_cad =
              dataCad[0].split("-").reverse().join("/") +
              " " +
              dataCad[1].slice(0, 8);
          }
          var data_atu = "null";
          if (tel.dataAtu !== null) {
            var dataAtu = tel.dataAtu.split("T");
            data_atu =
              dataAtu[0].split("-").reverse().join("/") +
              " " +
              dataAtu[1].slice(0, 8);
          }
          tA.rows.push({
            coluna1: tel.tipoTelefone,
            coluna2: "(" + tel.ddd + ") " + tel.numero,
            data_cad: data_cad,
            data_atu: data_atu,
            excluido:
              tel.excluido != "N" ? (
                <div style={{ color: "red" }}>Inativo</div>
              ) : (
                <div style={{ color: "green" }}>Ativo</div>
              ),
          });
        });
        // setState({ telantigo: tA });
        setTelantigo(tA);
      }
    }

    var eA = END_ANTIGO;
    if (resCliente.enderecos) {
      if (resCliente.enderecos.length > 0) {
        resCliente.enderecos.forEach((end) => {
          var data_cad = "null";
          if (end.dataCad !== null) {
            var dataCad = end.dataCad.split("T");
            data_cad =
              dataCad[0].split("-").reverse().join("/") +
              " " +
              dataCad[1].slice(0, 8);
          }
          var data_atu = "null";
          if (end.dataAtu !== null) {
            var dataAtu = end.dataAtu.split("T");
            data_atu =
              dataAtu[0].split("-").reverse().join("/") +
              " " +
              dataAtu[1].slice(0, 8);
          }
          eA.rows.push({
            coluna1: end.tipoEndereco,
            coluna2:
              end.rua +
              ", " +
              end.numero +
              ", " +
              (end.complemento === null ? " " : end.complemento),
            coluna4: end.bairro,
            coluna5: end.cep,
            coluna6: end.cidade + " / " + end.uf,
            data_cad: data_cad,
            data_atu: data_atu,
            excluido:
              end.excluido != "N" ? (
                <div style={{ color: "red" }}>Inativo</div>
              ) : (
                <div style={{ color: "green" }}>Ativo</div>
              ),
          });
        });
        // setState({ endantigo: eA });
        setEndantigo(eA);
      }
    }

    if (resCliente.proprietario) {
      var tA = prop;
      if (resCliente.proprietario.length > 0) {
        resCliente.proprietario.forEach((pro) => {
          var data_cad = "null";
          if (pro.data_cad !== null) {
            var dataCad = pro.data_cad.split("T");
            data_cad =
              dataCad[0].split("-").reverse().join("/") +
              " " +
              dataCad[1].slice(0, 8);
          }
          var data_atu = "null";
          if (pro.data_atu !== null) {
            var dataAtu = pro.data_atu.split("T");
            data_atu =
              dataAtu[0].split("-").reverse().join("/") +
              " " +
              dataAtu[1].slice(0, 8);
          }
          tA.rows.push({
            coluna1: pro.nome,
            cargo: pro.cargo,
            coluna2: pro.cpf,
            coluna3: pro.email === null ? " " : pro.email,
            coluna4: data_cad,
            coluna5: data_atu,
            coluna6: pro.celular === null ? " " : pro.celular,
            coluna7: (
              <MDBBtn
                color="info"
                md="sm"
                onClick={() => montaCadastro(pro.cpf)}
              >
                Consultar
              </MDBBtn>
            ),
          });
        });
        // setState({ propri: tA });
        setPropri(tA);
      }
    } else {
      if (resCliente.equipe != null) {
        var tA = prop;
        if (resCliente.equipe.length > 0) {
          resCliente.equipe.forEach((pro) => {
            var data_cad = "null";
            if (pro.data_cad !== null) {
              var dataCad = pro.data_cad.split("T");
              data_cad =
                dataCad[0].split("-").reverse().join("/") +
                " " +
                dataCad[1].slice(0, 8);
            }
            var data_atu = "null";
            if (pro.data_atu !== null) {
              var dataAtu = pro.data_atu.split("T");
              data_atu =
                dataAtu[0].split("-").reverse().join("/") +
                " " +
                dataAtu[1].slice(0, 8);
            }
            tA.rows.push({
              coluna1: pro.nome,
              cargo: pro.cargo,
              coluna2: pro.cpf,
              coluna3: pro.email === null ? " " : pro.email,
              coluna4: data_cad,
              coluna5: data_atu,
              coluna6: pro.celular === null ? " " : pro.celular,
              coluna7: (
                <MDBBtn
                  color="info"
                  md="sm"
                  onClick={() => montaCadastro(pro.cpf)}
                  className="gmb"
                >
                  Consultar
                </MDBBtn>
              ),
            });
          });
          // setState({ propri: tA });
          setPropri(tA);
        }
      }
    }
    // MudaVisibilidade("LoadingPage");

    var dadosLog = {
      // "idProjeto": getProjeto(),
      documento: cpf,
      origem: 20,
      url: window.location.pathname,
    };

    // await PostApi('LogAcesso/Salva', dadosLog);
  }, []);

  async function CarregaTiposTrans() {
    var retornoTipoTrans = { data: { sucesso: false } };
    // await GetApi("Extrato/ListaTipoTrans/" + getProjeto() + "/2");
    if (retornoTipoTrans.data.sucesso) {
      var TipoTransLista = retornoTipoTrans.data.listaTipos;
      // setState({ TipoTrans });
      setTipoTrans(TipoTransLista);
    }
  }

  async function Bonificar() {
    if (BonificacaoTipoTrans == "") {
      alert("Escolha o tipo de bonificação.");
    } else if (BonificacaoPontos <= 0) {
      alert("Quantidade de ponto precisa ser maior que 0.");
    } else {
      var retornoBonificar = { data: { sucesso: false } };
      // await GetApi("Extrato/BonificacaoManual/" + getProjeto() + "/" + cpf + "/" + BonificacaoPontos + "/" + BonificacaoTipoTrans);
      if (retornoBonificar.data.sucesso) {
        alert(retornoBonificar.data.mensagem);
        window.location.href = window.location.href;
      } else {
        alert(retornoBonificar.data.mensagem);
      }
    }
  }

  async function CarregaLoginLeo() {
    const defaultOptions = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Cache-Control": "no-cache",
      },
    };
    var dadosLeo = {
      DocumentoCliente: cpf,
      TokenAcessoOrigem: "B6C483F8-339F-496F-BD57-44E2680B2B58",
    };
    var respLoginleo = {};
    //  await apiLeo.post("requestautenticarcliente", JSON.stringify(dadosLeo), defaultOptions);
    // setState({ loginleo: loginleo.data });

    setLoginleo(respLoginleo.data);
  }

  async function CarregaPermissoes() {
    var resPermissoes = { data: { listaPermissoes: [] } };
    // await GetApi('Usuarios/BuscaPer/' + getProjeto());
    var perm = [];
    resPermissoes.data.listaPermissoes.map((per, i) => {
      var permissa = per.permissao.split(" - ");
      perm.push(permissa[1]);
    });
    // await setState({ permissoes: perm });
    setPermissoes(perm);

    if (perm.indexOf("Metas") != -1) {
      CarregaMetas();
    }
  }

  async function CarregaMetas() {
    var now = new Date();
    var dadosMetas = {
      // "idProjeto": getProjeto(),
      documento: cpf,
      mes: now.getMonth() + 1,
      ano: now.getFullYear(),
    };
    var resMetas = { data: { sucesso: false } };
    // await PostApi('Metas/Recupera', dadosMetas);
    if (resMetas.data.sucesso) {
      // setState({ metas: resMetas.data.metas });

      setMetas(resMetas.data.metas);
    }
    CarregaMetasHistorico(now.getFullYear());
  }

  async function CarregaMetasHistorico(ano, loading = false) {
    // setState({ anoSelect: ano });

    setAnoSelect(ano);
    if (loading) {
      // MudaVisibilidade("LoadingPage");
    }
    var now = new Date();
    var dadosMetas = {
      // "idProjeto": getProjeto(),
      documento: cpf,
      ano: ano,
      mes: now.getMonth() + 1,
      cnpj: loja.cnpj,
    };
    var resMetas = { data: { sucesso: false } };
    // await PostApi('Metas/RecuperaHistoricoLoja', dadosMetas);

    var metasH = METAS_HISTORICO_SIS;
    if (resMetas.data.sucesso) {
      // setState({ metasHistoricoSis: {} });
      setMetasHistoricoSis({});
      // setState({ MetaGrupo: resMetas.data.grupo });
      setMetaGrupo(resMetas.data.grupo);

      await resMetas.data.metas.forEach((met) => {
        met.mes = meses[met.mes - 1];
        met.meta = met.meta.toString();
        met.realizado = met.realizado.toString();
      });
      var metasHistoricoArray = [];
      let countedNames = resMetas.data.metas.reduce(function (allmetas, metas) {
        if (metas.industria == "Geral" && allmetas[metas.mes]) {
          allmetas[metas.mes].meta =
            parseInt(allmetas[metas.mes].meta) + parseInt(metas.meta);
          allmetas[metas.mes].realizado =
            parseInt(allmetas[metas.mes].realizado) + parseInt(metas.realizado);
          metasHistoricoArray.push(allmetas[metas.mes]);
        } else {
          allmetas[metas.mes] = metas;
          if (metas.industria != "Geral") {
            metasHistoricoArray.push(allmetas[metas.mes]);
          }
        }
        return allmetas;
      }, {});
      console.log(countedNames);
      metasH.rows = metasHistoricoArray;

      // await setState({ metasHistoricoSis: metasH, metasHistorico });
      setMetasHistoricoSis(metasH);
      setMetasHistorico(metasHistoricoArray);
    }
    if (loading) {
      // MudaVisibilidade("LoadingPage");
    }
  }

  async function buscaDep() {
    var resDepartamento = {};
    // await GetApi('Usuarios/BuscaDep/' + getProjeto());
    // setState({ departamentos: resDepartamento.data.listaDepartamentos });
    setDepartamentos(resDepartamento.data.listaDepartamentos);
  }

  async function buscaLogs() {
    var resLog = { data: { sucesso: false } };
    // await GetApi('/Log/BuscaLogCPF/' + getProjeto() + '/' + cpf);

    var logs = LOG_SISTEMA;
    if (resLog.data.sucesso) {
      // setState({ logsistema: {} });
      setLogsistema({});
      await resLog.data.logs.forEach((log) => {
        var dLog = log.data.split("T");
        dLog =
          dLog[0].split("-").reverse().join("/") + " " + dLog[1].slice(0, 8);

        logs.rows.push({
          codigo: log.cod,
          data: dLog,
          tabela: log.tabela,
          campo: log.campo,
          de: log.de,
          para: log.para === "" || log.para === null ? " " : log.para,
          alterado:
            log.alteradoPor === "" || log.alteradoPor === null
              ? " "
              : log.alteradoPor,
        });
      });
      // setState({ logsistema: logs });
      setLogsistema(logs);
    }
  }

  async function CarregaStatus() {
    var resStatusCliente = { data: { sucesso: false } };
    // await GetApi('Cliente/StatusCliente/' + getProjeto());
    if (resStatusCliente.data.sucesso) {
      // setState({ StatusCliente: resStatusCliente.data.listaStatus });

      setStatusCliente(resStatusCliente.data.listaStatus);
    }
  }

  async function buscaMotivos() {
    var resMotivos = { data: { sucesso: false } };
    // await GetApi('Motivos/Buscar/' + getProjeto());
    if (resMotivos.data.sucesso) {
      // setState({ motivos: resMotivos.data.listaMotivosPai });
      setMotivos(resMotivos.data.listaMotivosPai);
    }
  }

  async function selectDep(dep) {
    if (dep != "") {
      // setState({ DepEscolhido: dep });
      setDepEscolhido(dep);
      var users = {};
      // await GetApi('Usuarios/BuscarUserDep/' + dep);
      // setState({ usersDep: users.data.listaUsuarios });
      usersDep(users.data.listaUsuarios);
    }
  }

  async function finalizarAtendimento() {
    // MudaVisibilidade("LoadingPage");
    var ocorrencia = 0;
    if (ocorrenciaSTU != 0) {
      var dadosOco = {
        // "idProjeto": getProjeto(),
        documento: cpf,
        motivo: MotivoEscolhido,
        userEncaminhado: UserEscolhido,
        historico: historicoMSG,
      };

      var retOco = {};
      // await PostApi("Ocorrencias/Abrir", dadosOco);
      ocorrencia = retOco.data.ocoID;
    }

    var dadosEncerrar = {
      // "idProjeto": getProjeto(),
      atendimento: atendimento,
      motivo: MotivoEscolhido,
      ocorrencia: ocorrencia,
      historico: historicoMSG,
    };

    var retAte = { data: { sucesso: false } };
    // await PostApi("Atendimentos/Encerrar", dadosEncerrar);
    // MudaVisibilidade("LoadingPage");
    if (retAte.data.sucesso) {
      alert("Atendimento Finalizado com sucesso!");
      props.history.push("/Home");
    }
  }

  async function SelectLoja(loja) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    setCarregando(true);

    const retornoLoja = await fetch(
      `${URLBunge}/api/Cliente/BuscaDadosLoja/2329681/${loja}/${cpf}`,
      requestOptions
    )
    .then(response => response.json());
    console.log("***LOJA", retornoLoja);
    if (retornoLoja.sucesso) {
      setLoja(retornoLoja.loja);

      var now = new Date();
      CarregaMetasHistorico(now.getFullYear());
      var tA = prop;
      tA.rows = [];
      retornoLoja.equipe.forEach((pro) => {
        var data_cad = "null";
        if (pro.data_cad !== null) {
          var dataCad = pro.data_cad.split("T");
          data_cad =
            dataCad[0].split("-").reverse().join("/") +
            " " +
            dataCad[1].slice(0, 8);
        }
        var data_atu = "null";
        if (pro.data_atu !== null) {
          var dataAtu = pro.data_atu.split("T");
          data_atu =
            dataAtu[0].split("-").reverse().join("/") +
            " " +
            dataAtu[1].slice(0, 8);
        }
        tA.rows.push({
          coluna1: pro.nome,
          cargo: pro.cargo,
          coluna2: pro.cpf,
          coluna3: pro.email === null ? " " : pro.email,
          coluna4: data_cad,
          coluna5: data_atu,
          coluna6: pro.celular === null ? " " : pro.celular,
          coluna7: (
            <MDBBtn
              color="info"
              md="sm"
              onClick={() => montaCadastro(pro.cpf)}
              className="gmb"
            >
              Consultar
            </MDBBtn>
          ),
        });
      });
      setPropri(tA);
    }
    setCarregando(false)
  }

  async function CarregaPontuacao(cpfCliente) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

   
    if ("" === "") {
      const resPontuacao = await fetch(
        `${URLBunge}/api/Extrato/BuscarResumo/2329681/` + cpfCliente,
        requestOptions
      ).then((resp) => resp.json());

      if (resPontuacao.resumo != null) {
        setResumo({
          pontos: resPontuacao.resumo.pontos.toLocaleString("pt-BR"),
          vinculado: resPontuacao.resumo.vinculado.toLocaleString("pt-BR"),
          bonus: resPontuacao.resumo.bonus.toLocaleString("pt-BR"),
          premios: resPontuacao.resumo.premios.toLocaleString("pt-BR"),
          expirados: resPontuacao.resumo.expirados.toLocaleString("pt-BR"),
          total: resPontuacao.resumo.total.toLocaleString("pt-BR"),
        });
      }
    } else {
      var ExtratoResumoLeo = { data: { sucesso: false } };
      // await GetApi('Extrato/ExtratoResumoLeo/' + getProjeto() + '/' + cpf);
      if (ExtratoResumoLeo.sucesso) {
        setResumo({
          pontos:
            ExtratoResumoLeo.resumoPenca.pontosGanhos.toLocaleString("pt-BR"),
          vinculado:
            ExtratoResumoLeo.resumoPenca.bonusParaOutros.toLocaleString(
              "pt-BR"
            ),
          bonus:
            ExtratoResumoLeo.resumoPenca.bonusGanhos.toLocaleString("pt-BR"),
          premios:
            ExtratoResumoLeo.resumoPenca.pontosTrocados.toLocaleString("pt-BR"),
          expirados:
            ExtratoResumoLeo.resumoPenca.pontosExpirados.toLocaleString(
              "pt-BR"
            ),
          total:
            ExtratoResumoLeo.resumoPenca.saldoDisponivel.toLocaleString(
              "pt-BR"
            ),
        });
      }
    }
  }

  function montaCadastro(cpf) {
    window.open("/Clientes/" + cpf, "_blank");
  }

  async function selectOcorrencia(idOcorrencia) {
    // MudaVisibilidade("LoadingPage");
    buscaDep();
    buscaStu();
    var resOcorrencia = { data: { sucesso: false } };
    // await GetApi("Ocorrencias/Buscar/" + getProjeto() + "/" + idOcorrencia);
    if (resOcorrencia.data.sucesso) {
      // setState({ ocorreciaSelecionada: resOcorrencia.data });

      setOcorreciaSelecionada(resOcorrencia.data);
    }
    // setState({ ['modal33']: !state['modal33'] });
    setModal33((oldValue) => !oldValue);
    // MudaVisibilidade("LoadingPage");
  }

  async function buscaStu() {
    var resStatus = {};
    // await GetApi('Ocorrencias/BuscarStatus/' + getProjeto());
    // setState({ status: resStatus.data.listaStatus });
    setStatus(resStatus.data.listaStatus);
  }

  async function selectDep(dep) {
    if (dep != "") {
      // setState({ DepEscolhido: dep });
      setDepEscolhido(dep);
      var users = {};
      // await GetApi('Usuarios/BuscarUserDep/' + dep);
      // setState({ usersDep: users.data.listaUsuarios });
      setUsersDep(users.data.listaUsuarios);
    }
  }

  async function EncaminhaOcorrencia() {
    if (DepEscolhido == "") {
      alert("Escolha um departamento");
      return;
    }
    if (UserEscolhido == "") {
      alert("Escolha um Usuario para encaminhar a ocorrencia");
      return;
    }
    if (StatusEscolhido == "") {
      alert("Escolha um status para a ocorrencia");
      return;
    }
    if (historicoMSG == "") {
      alert("Digite um comentario.");
      return;
    }
    // MudaVisibilidade("LoadingPage");
    var dadosOco = {
      // "idProjeto": getProjeto(),
      idOcorrencia: ocorreciaSelecionada.codigoOcorrencia,
      documento: ocorreciaSelecionada.clienteCPF,
      departamento: DepEscolhido,
      status: StatusEscolhido,
      userEncaminhado: UserEscolhido,
      historico: historicoMSG,
    };

    var retOco = { data: { sucesso: false } };
    // await PostApi("Ocorrencias/Encaminhar", dadosOco);
    // MudaVisibilidade("LoadingPage");
    if (retOco.data.sucesso) {
      alert("Ocorrencia Encaminhada com sucesso!");
      // setState({ ['modal33']: !state['modal33'] });
      setModal33((oldValue) => !oldValue);
    }
  }

  async function ResetarSenha() {
    var retorno = { data: { sucesso: false } };
    // await GetApi("Projetos/ResetSenha/" + getProjeto() + "/" + cpf);
    if (retorno.data.sucesso) {
      alert("A senha do cliente foi resetada.");
      window.location.href = window.location.href;
    } else {
      alert("Algum erro ocorreu, Por favor tente novamente.");
      window.location.href = window.location.href;
    }
  }

  async function AttCadastro() {
    // MudaVisibilidade("LoadingPage");
    var sexoCod = sexoID;
    if (sexoCod == "") {
      if (sexo == "Feminino") {
        sexoCod = 22;
      } else if (sexo == "Masculino") {
        sexoCod = 23;
      } else if (sexo == "Não Informado") {
        sexoCod = 23061;
      } else {
        sexoCod = 0;
      }
    }

    var dadosAtt = {
      // "idProjeto": getProjeto(),
      documento: cpf,
      nome: nome,
      email: email,
      sexo: sexoCod,
      status: statusID,
    };
    var retAtt = { data: { sucesso: false } };
    // await PostApi("Cliente/AttCliente", dadosAtt);
    if (retAtt.data.sucesso) {
      alert("Dados atualizados com sucesso");
      // MudaVisibilidade("LoadingPage");
      window.location.href = window.location.href;
    } else {
      alert("Algum erro aconteceu.");
      // MudaVisibilidade("LoadingPage");
    }
  }

  async function addTelefone() {
    var dadosTel = {
      // "idProjeto": getProjeto(),
      documento: cpf,
      tipo: Tipo_Telefone,
      ddd: DDD_Telefone,
      numero: Numero_Telefone,
    };
    var retTel = { data: { sucesso: false } };
    // await PostApi("Cliente/AddTelefone", dadosTel);
    if (retTel.data.sucesso) {
      alert("Telefone cadastrado com sucesso");
      // MudaVisibilidade("LoadingPage");
      window.location.href = window.location.href;
    } else {
      alert("Algum erro aconteceu.");
      // MudaVisibilidade("LoadingPage");
    }
    // MudaVisibilidade("LoadingPage");
  }

  async function addEndereco() {
    var dadosEnd = {
      // "idProjeto": getProjeto(),
      documento: cpf,
      tipo: Tipo_Endereco_Cadastro,
      cep: Cep_Cadastro,
      endereco: Endereco_Cadastro,
      numero: Numero_Cadastro,
      complemento: Complemento_Cadastro,
      bairro: Bairro_Cadastro,
      cidade: Cidade_Cadastro,
      estado: Uf_Cadastro,
    };
    var retEnd = { data: { sucesso: false } };
    // await PostApi("Cliente/AddEndereco", dadosEnd);
    if (retEnd.data.sucesso) {
      alert("Endereço cadastrado com sucesso");
      // MudaVisibilidade("LoadingPage");
      window.location.href = window.location.href;
    } else {
      var msg = "Algum erro aconteceu.";
      if (retEnd.data.mensagem != "") {
        msg = retEnd.data.mensagem;
      }
      alert(msg);
      // MudaVisibilidade("LoadingPage");
    }
    // MudaVisibilidade("LoadingPage");
  }

  async function buscaCep() {
    // MudaVisibilidade("LoadingPage");
    if (Cep_Cadastro != "" && Cep_Cadastro != null) {
      var dados = Cep_Cadastro.trim();
      var response = { data: { sucesso: false } };
      // await GetApi("Transp/ConsultaCEP/" + dados);
      if (response.data.sucesso) {
        // setState({
        // Endereco_Cadastro: response.data.end,
        // Bairro_Cadastro: response.data.bairro,
        // Cidade_Cadastro: response.data.cidade,
        // Uf_Cadastro: response.data.uf,
        // Numero_Cadastro: "",
        // });

        setEndereco_Cadastro(response.data.end);
        setBairro_Cadastro(response.data.bairro);
        setCidade_Cadastro(response.data.cidade);
        setUf_Cadastro(response.data.uf);
        setNumero_Cadastro("");
      } else {
        alert("Cep invalido");
      }
    } else {
      alert("Digite um cep para pesquisar.");
    }

    // MudaVisibilidade("LoadingPage");
  }

  function verificaLogin() {
    if (TOKEN === null) {
      history.push({ pathname: "/", state: {} });
      setCarregando(false);
    }
  }

  useEffect(() => {
    // MUDA O TITULO DA PÁGINA
    document.title = "Plataforma Vendedor | Consulta de Clientes";

    // LIBERA O SCROLL DA PÁGINA
    document.body.style.overflow = "auto";

    //AO CARREGAR A PÁGINA SCROLA PARA O TOPO
    window.scrollTo(0, 0);

    verificaLogin();

    return () => {
      // TRAVA O SCROLL AO SAIR DA PÁGINA
      document.body.style.overflow = "hidden";
    };
  }, []);

  return (
    <Container>
      {carregando && <Carregando />}
      {/* <HeaderPortalVendedor  /> */}
      <MenuCliente cpf={cpf} />
      <MenuPrinc />

      <CadastrosCSS>
        <MDBBtn
          size="sm"
          color="info"
          onClick={() => history.goBack()}
        >
          <HiOutlineArrowSmLeft style={{ fontSize: "17px" }} />
          Voltar
        </MDBBtn>

        <div id="breadcrumb">
          <p>
            Consultar Cadastro {">"} Consultar Clientes {">"}{" "}
            <span style={{ fontWeight: "bold", color: "#043c54" }}>
              Usuário
            </span>
          </p>
        </div>
        {loginleo != "" && permissoes.indexOf("Logar") != -1 ? (
          <div>
            <MDBBtn
              color="primary"
              onClick={() =>
                window.open(
                  "http://amigoleo.leomadeiras.com.br/" + loginleo,
                  "_blank"
                )
              }
            >
              Logar no site
            </MDBBtn>
          </div>
        ) : (
          <div></div>
        )}

        <div className="clear"></div>

        {/* CADASTRO DA USUARIO*/}

        <MDBNav className="nav-tabs mt-5">
          <MDBNavItem className={activeItem === "1" ? "ativo" : ""}>
            <MDBNavLink
              to="#"
              active={activeItem === "1"}
              onClick={() => toggle("1")}
              role="tab"
            >
              <MDBIcon far icon="user-circle" /> Dados do Proprietário
            </MDBNavLink>
          </MDBNavItem>
          {loja === null ? (
            " "
          ) : (
            <MDBNavItem className={activeItem === "2" ? "ativo" : ""}>
              <MDBNavLink
                to="#"
                active={activeItem === "2"}
                onClick={() => toggle("2")}
                role="tab"
              >
                <MDBIcon icon="home" /> Dados da Loja
              </MDBNavLink>
            </MDBNavItem>
          )}
        </MDBNav>

        <MDBTabContent activeItem={activeItem}>
          {/* CADASTRO DO CLIENTE*/}
          <MDBTabPane tabId="1" role="tabpanel">
            <div className="cliente">
              <MDBRow>
                <MDBCol md="12">
                  <span className="blockquote bq-title bq-warning">
                    {" "}
                    Dados pessoais
                  </span>
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="CPF"
                    outline
                    size="lg"
                    value={cpfIncognito}
                  />
                </MDBCol>

                <MDBCol md="6">
                  <MDBInput
                    label="Nome"
                    outline
                    size="lg"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                  />
                </MDBCol>

                {permissoes.indexOf("Sexo") != -1 ? (
                  <MDBCol md="3" style={{ marginTop: "16px" }}>
                    <MDBInputGroup
                      size="lg"
                      containerClassName="mb-12"
                      prepend="Sexo"
                      inputs={
                        <select
                          className="browser-default custom-select"
                          onChange={(e) => setSexoID(e.target.value)}
                        >
                          <option
                            value="22"
                            selected={sexo == "Feminino" ? true : false}
                          >
                            Fem
                          </option>
                          <option
                            value="23"
                            selected={sexo == "Masculino" ? true : false}
                          >
                            Masc
                          </option>
                          <option
                            value="23061"
                            selected={
                              sexo == "Não Informado" || sexo == ""
                                ? true
                                : false
                            }
                          >
                            Não informado
                          </option>
                        </select>
                      }
                    />
                  </MDBCol>
                ) : (
                  <MDBCol md="3" style={{ marginTop: "16px" }}>
                    <MDBInput label="Sexo" outline size="lg" value={sexo} />
                  </MDBCol>
                )}
                {myLuxottica ? (
                  <MDBCol md="3">
                    <MDBInput
                      label="MyLuxottica"
                      outline
                      size="lg"
                      value={myLuxottica}
                    />
                  </MDBCol>
                ) : (
                  <MDBCol md="3">
                    <MDBInput
                      label="Codigo Cliente"
                      outline
                      size="lg"
                      value={codExt}
                    />
                  </MDBCol>
                )}

                <MDBCol md="3">
                  <MDBInput
                    label="Categoria"
                    outline
                    size="lg"
                    value={categoria}
                  />
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="Nascimento"
                    outline
                    size="lg"
                    value={dataNasc}
                    mask="99/99/9999"
                  />
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput label="Cargo" outline size="lg" value={cargo} />
                </MDBCol>

                <MDBCol md="6">
                  <MDBInput
                    label="Email"
                    value={email}
                    outline
                    size="lg"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="Tel Residencial"
                    outline
                    size="lg"
                    value={telFixo}
                  />
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="Tel Celular"
                    outline
                    size="lg"
                    value={celular}
                  />
                </MDBCol>

                {/* modal de consulta de telefone antigo*/}
                <MDBModal
                  isOpen={modal6}
                  toggle={() => toggleModal(6)}
                  size="lg"
                >
                  <MDBModalHeader toggle={() => toggleModal(6)}>
                    Telefones antigos
                  </MDBModalHeader>
                  <MDBModalBody>
                    <MDBTable responsive>
                      <MDBTableHead columns={telantigo.columns} />
                      <MDBTableBody rows={telantigo.rows} />
                    </MDBTable>
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn color="danger" onClick={() => toggleModal(6)}>
                      Fechar
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModal>

                {/* modal de cadastro de telefone antigo*/}
                <MDBModal
                  isOpen={modal7}
                  toggle={() => toggleModal(7)}
                  size="lg"
                >
                  <MDBModalHeader toggle={() => toggleModal(7)}>
                    Novo Telefone
                  </MDBModalHeader>
                  <MDBModalBody>
                    <MDBRow>
                      <MDBCol size="12">
                        <select
                          className="browser-default custom-select"
                          onChange={(e) => setTipo_Telefone(e.target.value)}
                        >
                          <option value="515">Residencial</option>
                          <option value="516">Comercial</option>
                          <option value="727">Celular</option>
                          <option value="1036">Outros</option>
                          <option value="1952">Fax</option>
                          <option value="2803">Comercial Omnion</option>
                          <option value="5318">Celular Excluido</option>
                          <option value="6226">Residencial Omnion</option>
                          <option value="6505">Comercial1</option>
                          <option value="8200">Celular Decisor</option>
                          <option value="8201">Celular Contato</option>
                          <option value="32014">Contato</option>
                        </select>
                      </MDBCol>

                      <MDBCol md="4">
                        <MDBInput
                          label="DDD"
                          outline
                          size="lg"
                          value={DDD_Telefone}
                          onChange={(e) => setDDD_Telefone(e.target.value)}
                        />
                      </MDBCol>

                      <MDBCol md="8">
                        <MDBInput
                          label="Numero"
                          outline
                          size="lg"
                          value={Numero_Telefone}
                          onChange={(e) => setNumero_Telefone(e.target.value)}
                        />
                      </MDBCol>

                      <MDBCol md="6">
                        <MDBBtn
                          color="cyan"
                          className="btn"
                          type="button"
                          onClick={() => addTelefone()}
                        >
                          Salvar Telefone
                        </MDBBtn>
                      </MDBCol>
                    </MDBRow>
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn color="default" onClick={() => toggleModal(7)}>
                      Fechar
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModal>

                <div className="clear"></div>

                {"" != 2334185 ? (
                  <MDBCol md="12">
                    <MDBCol md="12" className="sep">
                      <span className="blockquote bq-title bq-warning">
                        Pontuação do Cliente
                      </span>
                    </MDBCol>
                    <MDBCol md="3" style={{ float: "left" }}>
                      <MDBInput
                        label="Pontos Conquistados"
                        outline
                        size="lg"
                        value={resumo.pontos}
                      />
                    </MDBCol>

                    <MDBCol md="3" style={{ float: "left" }}>
                      <MDBInput
                        label="Bônus"
                        outline
                        size="lg"
                        value={resumo.bonus}
                      />
                    </MDBCol>

                    <MDBCol md="2" style={{ float: "left" }}>
                      <MDBInput
                        label="Prêmios"
                        outline
                        size="lg"
                        value={resumo.premios}
                      />
                    </MDBCol>

                    <MDBCol md="2" style={{ float: "left" }}>
                      <MDBInput
                        label="Expirados"
                        outline
                        size="lg"
                        value={resumo.expirados}
                      />
                    </MDBCol>

                    <MDBCol md="2" style={{ float: "left" }}>
                      <MDBInput
                        label="Saldo"
                        outline
                        size="lg"
                        disabled
                        className="sld"
                        value={resumo.total}
                      />
                    </MDBCol>
                    {permissoes.indexOf("Bonificar") != -1 ? (
                      <MDBCol md="3" style={{ float: "left" }}>
                        <MDBBtn
                          color="danger"
                          className="btn"
                          type="button"
                          onClick={() => toggleModal(777)}
                        >
                          Bonificar Participante
                        </MDBBtn>
                      </MDBCol>
                    ) : (
                      <div></div>
                    )}
                  </MDBCol>
                ) : (
                  <MDBCol md="12">
                    <MDBCol md="12" className="sep">
                      <span className="blockquote bq-title bq-warning">
                        Pontuação da Penca
                      </span>
                    </MDBCol>
                    <MDBCol md="4" style={{ float: "left" }}>
                      <MDBInput
                        label="Pontos ganhos ou recebidos por transferidos"
                        outline
                        size="lg"
                        value={resumo.pontos}
                      />
                    </MDBCol>

                    <MDBCol md="4" style={{ float: "left" }}>
                      <MDBInput
                        label="Bônus ganhos"
                        outline
                        size="lg"
                        value={resumo.bonus}
                      />
                    </MDBCol>

                    <MDBCol md="4" style={{ float: "left" }}>
                      <MDBInput
                        label="Bônus transf. para outros*"
                        outline
                        size="lg"
                        value={resumo.vinculado}
                      />
                    </MDBCol>

                    <MDBCol md="4" style={{ float: "left" }}>
                      <MDBInput
                        label="Pontos trocados"
                        outline
                        size="lg"
                        value={resumo.premios}
                      />
                    </MDBCol>

                    <MDBCol md="4" style={{ float: "left" }}>
                      <MDBInput
                        label="Pontos expirados"
                        outline
                        size="lg"
                        value={resumo.expirados}
                      />
                    </MDBCol>

                    <MDBCol md="4" style={{ float: "left" }}>
                      <MDBInput
                        label="Saldo disponível para troca"
                        outline
                        size="lg"
                        disabled
                        className="sld"
                        value={resumo.total}
                      />
                    </MDBCol>
                    {permissoes.indexOf("Bonificar") != -1 ? (
                      <MDBCol md="3" style={{ float: "left" }}>
                        <MDBBtn
                          color="danger"
                          className="btn"
                          type="button"
                          onClick={() => toggleModal(777)}
                        >
                          Bonificar Participante
                        </MDBBtn>
                      </MDBCol>
                    ) : (
                      <div></div>
                    )}
                  </MDBCol>
                )}

                <MDBModal
                  isOpen={modal777}
                  toggle={() => toggleModal(777)}
                  size="lg"
                >
                  <MDBModalHeader toggle={() => toggleModal(777)}>
                    Bonificar Participante
                  </MDBModalHeader>
                  <MDBModalBody>
                    <MDBRow>
                      <MDBCol size="12">
                        <select
                          className="browser-default custom-select"
                          onChange={(e) =>
                            setBonificacaoTipoTrans(e.target.value)
                          }
                        >
                          <option value="">
                            Selecione o tipo de bonificação
                          </option>
                          {TipoTrans.map((trans, i) => {
                            return (
                              <option key={i} value={trans.cod}>
                                {trans.descricao}
                              </option>
                            );
                          })}
                        </select>
                      </MDBCol>

                      <MDBCol md="4">
                        <MDBInput
                          label="Pontos"
                          outline
                          size="lg"
                          value={BonificacaoPontos}
                          onChange={(e) => setBonificacaoPontos(e.target.value)}
                        />
                      </MDBCol>
                    </MDBRow>
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn
                      color="cyan"
                      className="btn"
                      type="button"
                      onClick={() => Bonificar()}
                    >
                      Bonificar
                    </MDBBtn>
                    <MDBBtn color="danger" onClick={() => toggleModal(777)}>
                      Fechar
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModal>

                <div className="clear"></div>
                {permissoes.indexOf("Metas") != -1 && metas.length > 0 ? (
                  <MDBCol md="12">
                    <MDBCol md="12" className="sep">
                      <span className="blockquote bq-title bq-warning">
                        Metas Cliente
                      </span>
                    </MDBCol>
                    {metas.map((meta, i) => {
                      return (
                        <MDBRow key={i}>
                          <MDBCol md="3">
                            <MDBInput
                              label={meta.industria + ": Meta"}
                              outline
                              size="lg"
                              value={meta.meta}
                            />
                          </MDBCol>

                          <MDBCol md="3">
                            <MDBInput
                              label={meta.industria + ": Realizado"}
                              outline
                              size="lg"
                              value={meta.realizado}
                            />
                          </MDBCol>
                        </MDBRow>
                      );
                    })}
                  </MDBCol>
                ) : (
                  <div></div>
                )}

                <div className="clear"></div>

                <MDBCol md="12" className="sep">
                  <span className="blockquote bq-title bq-warning">
                    Endereço do cliente
                  </span>
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="Tipo"
                    outline
                    size="lg"
                    value={endereco != null ? endereco.tipoEndereco : ""}
                  />
                </MDBCol>

                <MDBCol md="6">
                  <MDBInput
                    label="Endereço"
                    outline
                    size="lg"
                    value={endereco != null ? endereco.rua : ""}
                  />
                </MDBCol>
                <MDBCol md="2">
                  <MDBInput
                    label="Numero"
                    outline
                    size="lg"
                    value={endereco != null ? endereco.numero : ""}
                  />
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="Compl"
                    outline
                    size="lg"
                    value={endereco != null ? endereco.complemento : ""}
                  />
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="Bairro"
                    outline
                    size="lg"
                    value={endereco != null ? endereco.bairro : ""}
                  />
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="CEP"
                    outline
                    size="lg"
                    value={endereco != null ? endereco.cep : ""}
                  />
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="Cidade/UF"
                    outline
                    size="lg"
                    value={
                      endereco != null
                        ? endereco.cidade + "/" + endereco.uf
                        : ""
                    }
                  />
                </MDBCol>

                {/* modal de Endereços antigos*/}
                <MDBModal
                  isOpen={modal4}
                  toggle={() => toggleModal(4)}
                  size="fluid"
                >
                  <MDBModalHeader toggle={() => toggleModal(4)}>
                    Endereços antigos
                  </MDBModalHeader>
                  <MDBModalBody>
                    <MDBTable responsive>
                      <MDBTableHead columns={endantigo.columns} />
                      <MDBTableBody rows={endantigo.rows} />
                    </MDBTable>
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn color="danger" onClick={() => toggleModal(4)}>
                      Fechar
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModal>

                {/* modal de cadastro de Novo endereço*/}
                <MDBModal
                  isOpen={modal5}
                  toggle={() => toggleModal(5)}
                  size="lg"
                >
                  <MDBModalHeader toggle={() => toggleModal(5)}>
                    Novo endereço
                  </MDBModalHeader>
                  <MDBModalBody>
                    <MDBRow>
                      <MDBCol md="12">
                        <select
                          className="browser-default custom-select"
                          size="lg"
                          onChange={(e) =>
                            setTipo_Endereco_Cadastro(e.target.value)
                          }
                        >
                          <option value="32">Residencial</option>
                          <option value="33">Comercial</option>
                          <option value="34">Alternativo</option>
                          <option value="2278">Remessa de Material</option>
                          <option value="2279">Correspondência</option>
                          <option value="2684">Comercial1</option>
                          <option value="2698">Entrega</option>
                          <option value="2699">Cobrança</option>
                        </select>
                      </MDBCol>

                      <MDBCol md="3">
                        <MDBInput
                          label="CEP"
                          outline
                          size="lg"
                          value={Cep_Cadastro}
                          onBlur={() => buscaCep()}
                          onChange={(e) => setCep_Cadastro(e.target.value)}
                        />
                      </MDBCol>

                      <MDBCol md="9">
                        <MDBInput
                          label="Endereço"
                          outline
                          size="lg"
                          value={Endereco_Cadastro}
                          onChange={(e) => setEndereco_Cadastro(e.target.value)}
                        />
                      </MDBCol>

                      <MDBCol md="2">
                        <MDBInput
                          label="Numero"
                          outline
                          size="lg"
                          value={Numero_Cadastro}
                          onChange={(e) => setNumero_Cadastro(e.target.value)}
                        />
                      </MDBCol>

                      <MDBCol md="4">
                        <MDBInput
                          label="Compl"
                          outline
                          size="lg"
                          value={Complemento_Cadastro}
                          onChange={(e) =>
                            setComplemento_Cadastro(e.target.value)
                          }
                        />
                      </MDBCol>

                      <MDBCol md="6">
                        <MDBInput
                          label="Bairro"
                          outline
                          size="lg"
                          value={Bairro_Cadastro}
                          onChange={(e) => setBairro_Cadastro(e.target.value)}
                        />
                      </MDBCol>

                      <MDBCol md="6">
                        <MDBInput
                          label="Cidade"
                          outline
                          size="lg"
                          value={Cidade_Cadastro}
                          onChange={(e) => setCidade_Cadastro(e.target.value)}
                        />
                      </MDBCol>

                      <MDBCol md="6">
                        <MDBInput
                          label="Estado"
                          outline
                          size="lg"
                          value={Uf_Cadastro}
                          onChange={(e) => setUf_Cadastro(e.target.value)}
                        />
                      </MDBCol>

                      <MDBCol md="6">
                        <MDBBtn
                          color="cyan"
                          className="btn"
                          type="button"
                          onClick={() => addEndereco()}
                        >
                          Salvar Endereço
                        </MDBBtn>
                      </MDBCol>
                    </MDBRow>
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn color="default" onClick={() => toggleModal(5)}>
                      Fechar
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModal>

                <div className="clear"></div>

                <MDBCol md="12" className="sep">
                  <span className="blockquote bq-title bq-warning">
                    Info de sistema
                  </span>
                </MDBCol>

                <MDBCol md="3">
                  <MDBInput
                    label="Última alteração"
                    outline
                    size="lg"
                    disabled
                    value={Ultima_Alteracao}
                  />
                </MDBCol>
                {permissoes.indexOf("Status") != -1 ? (
                  <MDBCol md="6" style={{ marginTop: "15px" }}>
                    <MDBInputGroup
                      size="lg"
                      disabled
                      containerClassName="mb-12"
                      prepend="Status de acesso"
                      inputs={
                        <select
                          className="browser-default custom-select"
                          onChange={(e) => setStatusID(e.target.value)}
                        >
                          {StatusCliente.map((sta, i) => {
                            return (
                              <option
                                value={sta.id}
                                selected={statusID == sta.id ? true : false}
                              >
                                {sta.descricao}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  </MDBCol>
                ) : (
                  <div></div>
                )}

                <MDBCol md="8">
                  {permissoes.indexOf("Reset de senha") != -1 ? (
                    <MDBBtn
                      color="red"
                      className="btn"
                      style={{ float: "right" }}
                      type="button"
                      onClick={() => ResetarSenha()}
                    >
                      Resetar Senha
                    </MDBBtn>
                  ) : (
                    <div></div>
                  )}
                </MDBCol>
              </MDBRow>
            </div>

            <div className="historico">
              <h2>Histórico de atendimento</h2>
              <div className="history">
                {Historico_Cliente.map((his, i) => {
                  var estilo = { color: "#212529" };
                  if (!his.status) {
                    estilo = { color: "red" };
                  }
                  var dataArr = his.data.split("T");
                  var dataHis =
                    dataArr[0].split("-").reverse().join("/") +
                    " " +
                    dataArr[1].slice(0, 8);
                  return (
                    <section>
                      <p style={estilo}>
                        <strong>Codigo:</strong> {his.codigo}
                        <br />
                        <strong>Atendente:</strong> {his.atendente}
                        <br />
                        <strong>Data:</strong>
                        {dataHis}
                        <br />
                        <strong>Motivo:</strong> {his.motivo}
                        <br />
                        {his.ocorrenciaId != null && his.ocorrenciaId > 0 ? (
                          <div>
                            <strong>Ocorrencia:</strong>{" "}
                            <MDBBtn
                              color="primary"
                              onClick={() => selectOcorrencia(his.ocorrenciaId)}
                            >
                              {his.codigo}
                            </MDBBtn>
                            <br />
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <strong>Texto:</strong>{" "}
                        <div
                          dangerouslySetInnerHTML={{ __html: his.texto }}
                        ></div>
                      </p>
                    </section>
                  );
                })}
              </div>

              <MDBModal
                isOpen={modal33}
                toggle={() => toggleModal(33)}
                fullHeight
                position="top"
              >
                <MDBModalHeader toggle={() => toggleModal(33)}>
                  Detalhe da Ocorrência
                </MDBModalHeader>
                <MDBModalBody>
                  <MDBRow>
                    <div data-test="col" class="col-md-12 sep">
                      <span class="blockquote bq-title bq-warning">
                        Dados de consulta
                      </span>
                    </div>
                    <MDBCol md="2">
                      <MDBInput
                        label="Código"
                        outline
                        size="lg"
                        value={
                          ocorreciaSelecionada.codigoAtendimento > 0
                            ? ocorreciaSelecionada.codigoAtendimento
                            : ocorreciaSelecionada.codigoOcorrencia
                        }
                      />
                    </MDBCol>

                    <MDBCol md="4">
                      <MDBInput
                        label="Nome"
                        outline
                        size="lg"
                        value={ocorreciaSelecionada.cliente}
                      />
                    </MDBCol>

                    <MDBCol md="3">
                      <MDBInput
                        label="CPF"
                        outline
                        size="lg"
                        value={ocorreciaSelecionada.clienteCPF}
                      />
                    </MDBCol>

                    <MDBCol md="3">
                      <MDBInput
                        label="Tel Celular"
                        outline
                        size="lg"
                        value={ocorreciaSelecionada.clienteTelefone}
                      />
                    </MDBCol>

                    <MDBCol md="6">
                      <MDBInput
                        label="Aberto por"
                        outline
                        size="lg"
                        value={ocorreciaSelecionada.abertoPor}
                      />
                    </MDBCol>

                    <MDBCol md="3">
                      <MDBInput
                        label="Motivo"
                        outline
                        size="lg"
                        value={ocorreciaSelecionada.motivo}
                      />
                    </MDBCol>

                    <MDBCol md="3">
                      <MDBInput
                        label="Status"
                        outline
                        size="lg"
                        value={ocorreciaSelecionada.status}
                      />
                    </MDBCol>

                    <div data-test="col" class="col-md-12 sep">
                      <span class="blockquote bq-title bq-warning">
                        Histórico da Ocorrência
                      </span>
                    </div>
                    <div className="clear"></div>
                    <br />

                    <MDBCol md="12">
                      <MDBTable striped>
                        <MDBTableHead>
                          <tr>
                            <th>Codigo</th>
                            <th>Quem abriu</th>
                            <th>Foi encaminhado para</th>
                            <th>Data</th>
                            <th>Status</th>
                            <th>Comentário</th>
                          </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                          {ocorreciaSelecionada.listaHistoricos.length > 0 ? (
                            ocorreciaSelecionada.listaHistoricos.map(
                              (listaHis, i) => {
                                var data = listaHis.data.split("T");
                                var dataMovimentacao = data[0]
                                  .split("-")
                                  .reverse()
                                  .join("/");
                                return (
                                  <tr>
                                    <td>{listaHis.codigo}</td>
                                    <td>{listaHis.userInicial}</td>
                                    <td>{listaHis.userEncaminahdo}</td>
                                    <td>{dataMovimentacao}</td>
                                    <td>{listaHis.status}</td>
                                    <td>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: listaHis.mensagem,
                                        }}
                                      ></div>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          ) : (
                            <tr>
                              <td colSpan="6">Sem Historico</td>
                            </tr>
                          )}
                        </MDBTableBody>
                      </MDBTable>
                    </MDBCol>
                    <div className="clear"></div>
                    <br />
                    {ocorreciaSelecionada.status != "ENCERRADA" ? (
                      <div class="row" style={{ margin: 0 }}>
                        <div data-test="col" class="col-md-12 sep">
                          <span class="blockquote bq-title bq-warning">
                            Adicionar/Encaminhar Comentários
                          </span>
                        </div>
                        <div className="clear"></div>
                        <br />

                        <MDBCol md="4">
                          <div className="clear"></div>
                          <MDBInputGroup
                            size="lg"
                            containerClassName="mb-12"
                            prepend="Departamento"
                            inputs={
                              <select
                                className="browser-default custom-select"
                                onChange={(e) => selectDep(e.target.value)}
                              >
                                <option value="">
                                  {" "}
                                  Selecione um Departamento
                                </option>
                                {departamentos.map((dep, i) => {
                                  return (
                                    <option value={dep.id}> {dep.nome}</option>
                                  );
                                })}
                              </select>
                            }
                          />
                        </MDBCol>

                        <MDBCol md="4">
                          <div className="clear"></div>
                          <MDBInputGroup
                            size="lg"
                            containerClassName="mb-12"
                            prepend="Encaminhar"
                            inputs={
                              <select
                                className="browser-default custom-select"
                                onChange={(e) =>
                                  setUserEscolhido(e.target.value)
                                }
                              >
                                <option value=""> Selecione o User</option>
                                {usersDep.map((usu, i) => {
                                  return (
                                    <option value={usu.id}> {usu.nome}</option>
                                  );
                                })}
                              </select>
                            }
                          />
                        </MDBCol>

                        <MDBCol md="4" style={{ marginTop: "15px" }}>
                          <MDBInputGroup
                            size="lg"
                            containerClassName="mb-12"
                            prepend="Status de acesso"
                            inputs={
                              <select
                                className="browser-default custom-select"
                                onChange={(e) =>
                                  setStatusEscolhido(e.target.value)
                                }
                              >
                                <option value=""> Selecione o Status</option>
                                {status.map((stu, i) => {
                                  return (
                                    <option value={stu.id}>
                                      {" "}
                                      {stu.descricao}
                                    </option>
                                  );
                                })}
                              </select>
                            }
                          />
                        </MDBCol>

                        <MDBCol md="12">
                          <label htmlFor="exampleFormControlTextarea1">
                            Adicionar Comentários
                          </label>
                          <JoditEditor
                            value={historicoMSG}
                            config={config}
                            className="textHtml"
                            onChange={(e) => setHistoricoMSG(e)}
                          />
                        </MDBCol>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </MDBRow>
                </MDBModalBody>
                <MDBModalFooter>
                  <MDBBtn color="primary" onClick={() => toggleModal(33)}>
                    Fechar
                  </MDBBtn>
                  {ocorreciaSelecionada.status != "ENCERRADA" ? (
                    <MDBBtn
                      color="light-green"
                      a
                      href="#"
                      onClick={() => EncaminhaOcorrencia()}
                    >
                      Gravar
                    </MDBBtn>
                  ) : (
                    <div></div>
                  )}
                </MDBModalFooter>
              </MDBModal>
            </div>
            <div className="clearfix"></div>
          </MDBTabPane>

          {/* CADASTRO DA LOJA*/}
          {loja === null ? (
            " "
          ) : (
            <MDBTabPane tabId="2" role="tabpanel">
              <div className="store">
                <MDBRow>
                  <MDBCol md="12">
                    <span className="blockquote bq-title bq-warning">
                      Dados da Loja
                    </span>
                  </MDBCol>
                  {lojas === null ? (
                    " "
                  ) : (
                    <MDBCol md="6" style={{ marginTop: "16px" }}>
                      <MDBInputGroup
                        size="lg"
                        containerClassName="mb-12"
                        prepend="Lojas"
                        inputs={
                          <select
                            className="browser-default custom-select"
                            onChange={(e) => SelectLoja(e.target.value)}
                          >
                            {lojas.map((loj, i) => {
                              var cargoLoja =
                                loj.cargo != null && loj.cargo != "null"
                                  ? loj.cargo
                                  : "";
                              return (
                                <option value={loj.cnpj} key={i}>
                                  {loj.cnpj + " " + loj.nome + " " + cargoLoja}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                    </MDBCol>
                  )}
                  <div className="clear"></div>
                  <MDBCol md="4">
                    <MDBInput
                      label="CNPJ"
                      outline
                      size="lg"
                      value={loja.cnpj}
                    />
                  </MDBCol>

                  <MDBCol md="4">
                    <MDBInput
                      label="Razao"
                      outline
                      size="lg"
                      value={loja.razao}
                    />
                  </MDBCol>

                  <MDBCol md="4">
                    <MDBInput
                      label="Categoria"
                      outline
                      size="lg"
                      value={loja.categoria}
                    />
                  </MDBCol>

                  <MDBCol md="2">
                    <MDBInput
                      label="Grupo"
                      outline
                      size="lg"
                      value={loja.grupo}
                    />
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput
                      label="Codigo Cliente"
                      outline
                      size="lg"
                      value={loja.codExt}
                    />
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput label="IE" outline size="lg" value={loja.ie} />
                  </MDBCol>

                  <MDBCol md="4">
                    <MDBInput
                      label="Email"
                      value={loja.email}
                      outline
                      size="lg"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </MDBCol>

                  <MDBCol md="5">
                    <MDBInput
                      label="Telefone da loja"
                      outline
                      size="lg"
                      value={loja.telefoneLoja}
                    />
                  </MDBCol>

                  <MDBCol md="12" className="sep">
                    <span className="blockquote bq-title bq-warning">
                      Endereço da Loja
                    </span>
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput
                      label="Tipo"
                      outline
                      size="lg"
                      value={
                        loja.endereco != undefined
                          ? loja.endereco.tipoEndereco
                          : ""
                      }
                    />
                  </MDBCol>

                  <MDBCol md="9">
                    <MDBInput
                      label="Endereço"
                      outline
                      size="lg"
                      value={
                        loja.endereco != undefined ? loja.endereco.rua : ""
                      }
                    />
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput
                      label="Compl"
                      outline
                      size="lg"
                      value={
                        loja.endereco != undefined
                          ? loja.endereco.complemento
                          : ""
                      }
                    />
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput
                      label="Bairro"
                      outline
                      size="lg"
                      value={
                        loja.endereco != undefined ? loja.endereco.bairro : ""
                      }
                    />
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput
                      label="CEP"
                      outline
                      size="lg"
                      value={
                        loja.endereco != undefined ? loja.endereco.cep : ""
                      }
                    />
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput
                      label="Cidade/UF"
                      outline
                      size="lg"
                      value={
                        loja.endereco != undefined
                          ? loja.endereco.cidade + "/" + loja.endereco.uf
                          : ""
                      }
                    />
                  </MDBCol>

                  <div className="clear"></div>
                  <MDBCol md="12">
                    <span className="blockquote bq-title bq-warning">
                      Info de sistema
                    </span>
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput
                      label="Acesso ao site"
                      outline
                      size="lg"
                      value={loja.infoSistema.status}
                    />
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput
                      label="Troca SITE/SAO"
                      outline
                      size="lg"
                      value={Site_Sao_Loja}
                    />
                  </MDBCol>

                  <MDBCol md="3">
                    <MDBInput
                      label="Última alteração"
                      outline
                      size="lg"
                      value={Ultima_Alteracao_Loja}
                    />
                  </MDBCol>

                  <div className="clear"></div>
                  <br />
                  <br />
                  <MDBCol md="12">
                    <span className="blockquote bq-title bq-warning">
                      {proprietario !== null
                        ? "Proprietário/Sócio desta loja"
                        : "Equipe desta loja"}
                    </span>
                  </MDBCol>

                  <MDBCol md="12">
                    <MDBTable responsive>
                      <MDBTableHead columns={prop.columns} />
                      <MDBTableBody rows={propri.rows} />
                    </MDBTable>
                  </MDBCol>
                </MDBRow>
              </div>

              <div className="clearfix"></div>
            </MDBTabPane>
          )}

          {/* LOG DE SISTEMA*/}
          <MDBTabPane tabId="3" role="tabpanel">
            <MDBDataTable
              striped
              bordered
              hover
              searchLabel="Pesquisar"
              paginationLabel={["Anterior", "Próximo"]}
              noRecordsFoundLabel="Nenhum resultado encontrado"
              infoLabel={["Mostrando", "de", "até", "registros"]}
              entriesLabel="Qtd por pagina"
              data={logsistema}
            />
          </MDBTabPane>

          {metasHistorico.length > 0 ? (
            <MDBTabPane tabId="4" role="tabpanel">
              {MetaGrupo != null && MetaGrupo != "" ? (
                <MDBCol md="12">
                  <span className="blockquote bq-title bq-warning">
                    Grupo: {MetaGrupo}
                  </span>
                </MDBCol>
              ) : (
                <div></div>
              )}

              <MDBCol md="6" style={{ marginTop: "16px" }}>
                <MDBInputGroup
                  size="lg"
                  containerClassName="mb-12"
                  prepend="Ano"
                  inputs={
                    <select
                      className="browser-default custom-select"
                      onChange={(e) =>
                        CarregaMetasHistorico(e.target.value, true)
                      }
                    >
                      <option
                        value="2020"
                        checked={anoSelect == 2020 ? true : false}
                      >
                        2020
                      </option>
                      <option
                        value="2019"
                        checked={anoSelect == 2019 ? true : false}
                      >
                        2019
                      </option>
                    </select>
                  }
                />
              </MDBCol>
              <MDBDataTable
                striped
                bordered
                hover
                searchLabel="Pesquisar"
                paginationLabel={["Anterior", "Próximo"]}
                noRecordsFoundLabel="Nenhum resultado encontrado"
                infoLabel={["Mostrando", "de", "até", "registros"]}
                entriesLabel="Qtd por pagina"
                data={metasHistoricoSis}
              />
            </MDBTabPane>
          ) : (
            <div></div>
          )}

          {/* EXTRATO DE PONTOS FORNADA*/}
          <MDBTabPane tabId="5" role="tabpanel">
            <div className="extrato">
              <MDBCol md="6" style={{ float: "left" }}>
                <MDBInputGroup
                  size="lg"
                  containerClassName="mb-12"
                  prepend="cargo"
                  inputs={
                    <select className="browser-default custom-select">
                      <option value="">Proprietario 1</option>
                      <option value="">Proprietario 2</option>
                    </select>
                  }
                />
              </MDBCol>

              <MDBCol md="6" style={{ float: "left" }}>
                <MDBInputGroup
                  size="lg"
                  containerClassName="mb-12"
                  prepend="cargo"
                  inputs={
                    <select className="browser-default custom-select">
                      <option value="">Resumo</option>
                      <option value="">Pontos Conquistados</option>
                      <option value="">Bônus</option>
                      <option value="">Pontos Resgatados</option>
                    </select>
                  }
                />
              </MDBCol>

              <div className="clear"></div>

              <div className="resumo" id="resumo">
                <h2>RESUMO</h2>
                <dl className="bg">
                  <dt>Pontos Conquistados</dt>
                  <dt>Bônus</dt>
                  <dt>Pontos Resgatados</dt>
                  <dt>Pontos Expirados</dt>
                  <dt>Pontos disponíveis para troca</dt>
                </dl>

                <dl>
                  <dd></dd>
                  <dd></dd>
                  <dd></dd>
                  <dd></dd>
                  <dd></dd>
                </dl>
              </div>

              <div className="conquistados" id="conquistados">
                <h2>PONTOS CONQUISTADOS</h2>
                <dl className="bg">
                  <dt>Data</dt>
                  <dt>Tipo</dt>
                  <dt>Pontos</dt>
                </dl>

                <dl>
                  <dd></dd>
                  <dd></dd>
                  <dd></dd>
                </dl>
              </div>

              <div className="bonus">
                <h2>BÔNUS</h2>
                <dl className="bg">
                  <dt>Data</dt>
                  <dt>Tipo</dt>
                  <dt>Pontos</dt>
                </dl>

                <dl>
                  <dd></dd>
                  <dd></dd>
                  <dd></dd>
                </dl>
              </div>

              <div className="resgatados">
                <h2>PONTOS RESGATADOS</h2>
                <dl className="bg">
                  <dt>Data</dt>
                  <dt>Produto</dt>
                  <dt>Pontos</dt>
                  <dt>Status da Troca</dt>
                </dl>

                <dl>
                  <dd></dd>
                  <dd></dd>
                  <dd></dd>
                  <dd></dd>
                </dl>
              </div>

              <div className="expira">
                <h2>PONTOS A EXPIRAR</h2>

                <dl className="bg">
                  <dt>Data da expiração</dt>
                  <dt>Pontos</dt>
                </dl>

                <dl>
                  <dd></dd>
                  <dd></dd>
                </dl>
              </div>
            </div>
            <div className="clear"></div>
          </MDBTabPane>

          {/* MODAL DE DETALHE DO ATENDIMENTO   */}
          <MDBModal
            isOpen={modal10}
            toggle={() => toggleModal(10)}
            fullHeight
            backdrop={false}
            position="right"
            className="modaldetalhe"
          >
            <MDBModalHeader toggle={() => toggleModal(10)}>
              {" "}
              Histórico, Motivos e Ocorrências
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <div className="form-group">
                  <label htmlFor="exampleFormControlTextarea1">
                    Adicionar Comentário
                  </label>
                  <JoditEditor
                    value={historicoMSG}
                    config={config}
                    className="textHtml"
                    onChange={(e) => setHistoricoMSG(e)}
                  />
                </div>

                <div className="clear"></div>
                <br />

                {motivos.length > 0 ? (
                  motivos.map((motPai, i) => {
                    return (
                      <div>
                        <div
                          className="acord"
                          id={"paizao" + i}
                          href=""
                          onClick={() => toggleCollapse(motPai.id, i)}
                        >
                          {" "}
                          {motPai.nome}{" "}
                        </div>
                        <MDBCollapse id={motPai.id} isOpen={collapseID}>
                          <div className="escolhas">
                            {motPai.listaMotivosFilhos.map((motFilho, j) => {
                              return (
                                <div>
                                  <input
                                    type="radio"
                                    name="motivo"
                                    id={"motivo" + motFilho.id}
                                    onClick={() => {
                                      setMotivoEscolhido(motFilho.id);
                                      setMotivoEscolhidoDesc(motFilho.nome);
                                    }}
                                    value={motFilho.id}
                                  />
                                  <label for={"motivo" + motFilho.id}>
                                    {motFilho.nome}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </MDBCollapse>
                      </div>
                    );
                  })
                ) : (
                  <div></div>
                )}

                <div className="clear"></div>
                <br />

                {/* CRIANDO OCORRENCIAS*/}
                {/* OBS: verficar DivOcorrencia */}
                <MDBInput
                  label="Criar uma Ocorrência para este atendimento"
                  onClick={() => {
                    MudaVisibilidade("DivOcorrencia");
                    ocorrenciaSTU == 1
                      ? setOcorrenciaSTU(0)
                      : setOcorrenciaSTU(1);
                  }}
                  filled
                  type="checkbox"
                  className="check"
                  id="nova_ocorrencia"
                />
                <div id="DivOcorrencia" style={{ display: "none" }}>
                  <MDBRow>
                    <MDBCol md="12">
                      <MDBInput
                        label="Nº Ocorrência"
                        outline
                        size="lg"
                        value={atendimento}
                      />
                    </MDBCol>

                    <MDBCol md="12">
                      <MDBInput
                        label="Cliente"
                        outline
                        size="lg"
                        value={nome}
                      />
                    </MDBCol>

                    <MDBCol md="12">
                      <MDBInput
                        label="Assunto"
                        outline
                        size="lg"
                        value={MotivoEscolhidoDesc}
                      />
                    </MDBCol>

                    <MDBCol md="12">
                      <div className="clear"></div>
                      <MDBInputGroup
                        size="lg"
                        containerClassName="mb-12"
                        prepend="Departamento"
                        inputs={
                          <select
                            className="browser-default custom-select"
                            onChange={(e) => selectDep(e.target.value)}
                          >
                            <option value=""> Selecione um Departamento</option>
                            {departamentos.map((dep, i) => {
                              return (
                                <option value={dep.id}> {dep.nome}</option>
                              );
                            })}
                          </select>
                        }
                      />
                    </MDBCol>

                    <MDBCol md="12">
                      <div className="clear"></div>
                      <MDBInputGroup
                        size="lg"
                        containerClassName="mb-12"
                        prepend="Encaminhar"
                        inputs={
                          <select
                            className="browser-default custom-select"
                            onChange={(e) => setUserEscolhido(e.target.value)}
                          >
                            <option value=""> Selecione o User</option>
                            {usersDep.map((usu, i) => {
                              return (
                                <option value={usu.id}> {usu.nome}</option>
                              );
                            })}
                          </select>
                        }
                      />
                    </MDBCol>
                  </MDBRow>
                </div>
              </form>
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color="indigo" onClick={() => toggleModal(10)}>
                Fechar
              </MDBBtn>
              <MDBBtn
                color="light-green"
                href="#"
                onClick={() => finalizarAtendimento()}
              >
                Gravar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>
        </MDBTabContent>
      </CadastrosCSS>
    </Container>
  );
}

export default ConsultarClientes;
